// third-party
import { createSlice } from '@reduxjs/toolkit';
import { devConsolelog } from 'helpers/utilityFunctions';

// project imports
import { ARYABHATTA_API_DOMAIN_V1 } from 'config';
import { returnFiltersQueryString } from 'helpers/objectFunctions';
import { dispatch } from 'store';
import axios from 'utils/axios';
import { BOOKING_TYPE, CATEGORY_ACCOMODATION, CATEGORY_FLIGHTS, PAX_TYPE } from 'views/pages/booking-requests/constant';
import { openSnackbar } from './snackbar';

const DEFAULT_ERROR_MESSAGE = 'Something Went Wrong';

const initialState = {
    inActiveUpdates: [],
    isLoading: false,
    activeUpdates: [],
    addingAnnouncement: false
};

const slice = createSlice({
    name: 'onTripAnnouncement',
    initialState,
    reducers: {
        setActiveUpdates(state, action) {
            state.activeUpdates = action.payload;
        },
        setInactiveUpdates(state, action) {
            state.inActiveUpdates = action.payload;
        },
        setIsLoading(state, action) {
            state.isLoading = action.payload;
        },
        setAnnouncemetnForm(state, action) {
            state.addingAnnouncement = action.payload;
        }
    }
});

// Reducer
export default slice.reducer;
export const { setActiveUpdates, setInactiveUpdates, setAnnouncemetnForm } = slice.actions;
export const postAnnouncementDetails = (bookingCode = '', payload) => {
    dispatch(slice.actions.setIsLoading(true));
    return async () => {
        const url = `${ARYABHATTA_API_DOMAIN_V1}holidays/booking/${bookingCode}/trip-updates/`;
        try {
            const response = await axios.post(url, payload);
            dispatch(slice.actions.setAnnouncemetnForm(false));
            devConsolelog('response of ontrip Announcement', response?.data);
        } catch (error) {
            const { error: errorObj = {}, detail = '' } = error || {};
            const { errorMessage = '' } = errorObj || {};
            dispatch(
                openSnackbar({
                    open: true,
                    message: errorMessage || detail || DEFAULT_ERROR_MESSAGE,
                    variant: 'alert',
                    alert: {
                        color: 'error'
                    },
                    close: false
                })
            );
        } finally {
            dispatch(slice.actions.setIsLoading(false));
        }
    };
};
